module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/8b4c8d4697a1500dbd87013c9a0476a6.jpg";